<template>
    <section class="administration-selectlists">
        <!-- Select lists-->
        <div class="administration-selectlists-group">
            <div class="section-header">Værdilister</div>
            <div class="grid-x selectlists-group" ref="selectListGroup">
                <div class="cell" v-if="orderedSelectLists && orderedSelectLists.length > 0">
                    <transition-group class="grid-x" name="list" tag="div">
                        <div class="large-2 item" v-for="userSelectList in orderedSelectLists" :ref="userSelectList[0].listName" :key="userSelectList[0].listName" @click="setUserSelectList(userSelectList[0].systemName)" :class="{'selected': userSelectList[0].systemName === selectedListSystemName}">
                            <span class="truncate-ellipse with-icon">{{userSelectList[0].listName}}</span>
                            <icon class="small-svg fill-dark-gray" name="drop-down-list" />
                        </div>
                    </transition-group>
                </div>
                <div v-else class="user-feedback-list-group">Et øjeblik. Værdilister hentes...</div>
            </div>
        </div>

        <hr />

        <div class="form-view">
            <div class="form">
                <div class="grid-x select-supply-wrapper" style="margin-top: 10px">
                    <div class="cell small-1 flexbox-center">
                        <icon class="supply-type small-svg fill-dark-gray" name="supply-type" />
                    </div>
                    <div class="cell small-3 flexbox-align-items">
                        <p>Forretningsområde</p>
                    </div>
                    <div class="cell auto flexbox-align-items select-supply">
                        <div class="grid-x">
                            <div class="select-supply-container" v-for="businessAreaType in businessAreaTypeList" v-bind:key="businessAreaType.code" @click="selectBusinessAreaType(businessAreaType)">
                                <div class="button-radio-round" :id="businessAreaType.systemName.toLowerCase()" :class="{'selected-supply': checkSelectedBusinessArea(businessAreaType.systemName)}">
                                    <icon class="small-svg fill-white" :name="businessAreaType.systemName.toLowerCase()" />
                                </div>
                                <span>{{businessAreaType.description}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="grid-x selectlist-actions">
            <div class="cell small-12 flexbox-end">
                <input type="text" style="float: left; width: 40%" id="newselectitem" v-model="enteredNewItem" />
                <button class="button button-small" style="margin-bottom: 15px" @click="addNewItem()">
                    <icon class="small-svg fill-white" name="drop-down-list" />
                    Tilføj
                </button>
            </div>
        </div>
        <div v-if="selectedUserSelectList && selectedUserSelectList.list.length > 0" class="grid-x list-sort">
            <div class="cell large-1" style="cursor: default"></div>
            <div class="cell large-4 item flexbox" style="cursor: default">
                <span>Værdi på liste</span>
            </div>
            <div class="cell item flexbox" style="cursor: default" :class="isProblemType ? 'large-3' : 'large-4'">
                <span>Tags</span>
            </div>
            <div class="cell large-2 item flexbox-center" style="cursor: default" :class="isProblemType ? 'large-2' : 'large-3'">
                <span>Anvendelse</span>
            </div>
            <div v-if="isProblemType" class="cell large-1" style="cursor: default"></div>
            <div v-if="isProblemType" class="cell large-1" style="cursor: default">Synlig eksternt</div>
        </div>
        <template v-if="selectedUserSelectList">
            <transition-group name="list" tag="div">
                <div v-for="listItem in selectedUserSelectList.list" :key="listItem.typeId" @click="openModal('administration-modal-selectlistitem-drive', listItem)">
                    <div class="cell small-12">
                        <div class="grid-x list-row align-items">
                            <div class="cell large-1 flexbox-center">
                                <icon class="user medium-svg fill-dark-gray" name="drop-down-list" />
                            </div>
                            <div class="cell large-4 item flexbox-align-items">
                                <span class="truncate-ellipse">{{listItem.description}}</span>
                            </div>
                            <div class="cell item flexbox-align-items" :class="isProblemType ? 'large-3' : 'large-4'" style="flex-wrap: wrap;">
                                <div v-for="(tag, index) in listItem.tagList" :key="index" style="margin-bottom: 5px;">
                                    <span class="tag">{{ tag.description }}</span>
                                </div>
                            </div>
                            <div class="cell item flexbox-center" :class="isProblemType ? 'large-2' : 'large-3'">
                                <div class="listitem-status" :class="{'disabled-item': !listItem.used}">
                                    <span v-if="listItem.used === true">Anvendes</span>
                                    <span v-else>Anvendes ikke</span>
                                </div>
                            </div>
                            <div v-if="isProblemType" class="cell large-1 flexbox-center">
                                <icon v-if="listItem.taskTemplateId" class="user medium-svg fill-dark-gray" name="template" />
                            </div>
                            <div v-if="isProblemType" class="cell large-1 flexbox-center">
                                {{ listItem.isPublic ? 'Ja' : 'Nej' }}
                            </div>
                        </div>
                    </div>
                </div>
            </transition-group>
        </template>
    </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
    data () {
        return {
            selectedListSystemName: null,
            enteredNewItem: null
        }
    },
    computed: {
        ...mapGetters({
            userSelectLists: 'getUserSelectLists',
            selectedUserSelectList: 'getSelectedUserSelectList',
            selectedBusinessAreaSystemName: 'getSelectedBusinessAreaSystemName',
            businessAreaTypeList: 'getSysBusinessAreaTypeList',
            applicationList: 'getApplicationList'
        }),

        orderedSelectLists () {
            if (this.userSelectLists && this.userSelectLists.length > 0) {
                this.userSelectLists.sort((a, b) => {
                    if (a[0].listName < b[0].listName) {
                        return -1
                    }
                    if (a[0].listName > b[0].listName) {
                        return 1
                    }
                    return 0
                })
                return this.userSelectLists
            } else {
                return 0
            }
        },

        isActivityType () {
            return this.selectedListSystemName === 'activitytype'
        },
        isEstateType () {
            return this.selectedListSystemName === 'estatetype'
        },
        isClientType () {
            return this.selectedListSystemName === 'clienttype'
        },
        isProblemType () {
            return this.selectedListSystemName === 'problemtype'
        },
        isWeatherType () {
            return this.selectedListSystemName === 'weathertype'
        }
    },
    methods: {
        ...mapActions({
            setApplication: 'setApplication',
            setAllCodeLists: 'setAllCodeLists',
            setApplicationSettingsDrive: 'setApplicationSettingsDrive',
            setSelectedUserSelectListItem: 'setSelectedUserSelectListItem',
            setSelectedUserSelectList: 'setSelectedUserSelectList',
            setSelectedBusinessAreaSystemName: 'setSelectedBusinessAreaSystemName',
            createUpdateActivityType: 'createUpdateActivityType',
            createUpdateClientType: 'createUpdateClientType',
            createUpdateEstateType: 'createUpdateEstateType',
            createUpdateProblemType: 'createUpdateProblemType',
            createUpdateWeatherType: 'createUpdateWeatherType'
        }),
        selectBusinessAreaType (businessAreaType) {
            if (businessAreaType) {
                this.setSelectedBusinessAreaSystemName(businessAreaType.systemName)
                this.setActiveSelectList()
            }
        },
        checkSelectedBusinessArea (businessAreaTypeSystemName) {
            if (this.selectedBusinessAreaSystemName === businessAreaTypeSystemName) {
                return true
            } else {
                return false
            }
        },
        setUserSelectList (systemName) {
            if (systemName) {
                this.selectedListSystemName = systemName
                this.setActiveSelectList()
            }
        },
        setActiveSelectList () {
            if (this.selectedListSystemName && this.selectedBusinessAreaSystemName) {
                let selList = this.userSelectLists.filter(i => i[0].systemName === this.selectedListSystemName)[0]

                let codelist = []
                let businessAreaTypeId = null

                switch (this.selectedBusinessAreaSystemName) {
                case 'sewer':
                    codelist = selList[1].sewer.codeList
                    businessAreaTypeId = selList[1].sewer.businessAreaTypeId
                    break
                case 'water':
                    codelist = selList[1].water.codeList
                    businessAreaTypeId = selList[1].water.businessAreaTypeId
                    break
                case 'treatmentplant':
                    codelist = selList[1].treatmentplant.codeList
                    businessAreaTypeId = selList[1].treatmentplant.businessAreaTypeId
                    break
                case 'administration':
                    codelist = selList[1].administration.codeList
                    businessAreaTypeId = selList[1].administration.businessAreaTypeId
                    break
                case 'trash':
                    codelist = selList[1].trash.codeList
                    businessAreaTypeId = selList[1].trash.businessAreaTypeId
                    break
                case 'streetlights':
                    codelist = selList[1].streetLights.codeList
                    businessAreaTypeId = selList[1].streetLights.businessAreaTypeId
                    break
                case 'greencare':
                    codelist = selList[1].greenCare.codeList
                    businessAreaTypeId = selList[1].greenCare.businessAreaTypeId
                    break
                }

                if (codelist && codelist.length > 0) {
                    codelist.sort((a, b) => {
                        if (a.description < b.description) {
                            return -1
                        }
                        if (a.description > b.description) {
                            return 1
                        }
                        return 0
                    })
                }

                let lst = {
                    'list': codelist,
                    'listName': selList[0].listName,
                    'systemName': selList[0].systemName,
                    'businessAreaTypeId': businessAreaTypeId
                }
                this.setSelectedUserSelectList(lst)
            }
        },
        addNewItem () {
            if (this.enteredNewItem && this.enteredNewItem.length > 0) {
                if (this.selectedUserSelectList.systemName === 'activitytype') {
                    this.createUpdateActivityType({
                        deleteListItem: false,
                        cActivityTypeId: null,
                        businessAreaTypeId: this.selectedUserSelectList.businessAreaTypeId,
                        code: 0,
                        description: this.enteredNewItem,
                        tagList: []
                    })
                        .then((response) => {
                            if (response.status === 200) {
                                this.$emit('close')
                            }
                        })
                } else if (this.selectedUserSelectList.systemName === 'clienttype') {
                    this.createUpdateClientType({
                        deleteListItem: false,
                        cClientTypeId: null,
                        businessAreaTypeId: this.selectedUserSelectList.businessAreaTypeId,
                        description: this.enteredNewItem,
                        tagList: []
                    })
                        .then((response) => {
                            if (response.status === 200) {
                                this.$emit('close')
                            }
                        })
                } else if (this.selectedUserSelectList.systemName === 'estatetype') {
                    this.createUpdateEstateType({
                        deleteListItem: false,
                        eEstateTypeId: null,
                        businessAreaTypeId: this.selectedUserSelectList.businessAreaTypeId,
                        description: this.enteredNewItem
                    })
                        .then((response) => {
                            if (response.status === 200) {
                                this.$emit('close')
                            }
                        })
                } else if (this.selectedUserSelectList.systemName === 'problemtype') {
                    this.createUpdateProblemType({
                        deleteListItem: false,
                        cProblemTypeId: null,
                        businessAreaTypeId: this.selectedUserSelectList.businessAreaTypeId,
                        description: this.enteredNewItem,
                        tagList: [],
                        isPublic: false,
                        taskTemplateId: null,
                        defaultOwnerUserId: null,
                        publicDescription: ''
                    })
                        .then((response) => {
                            if (response.status === 200) {
                                this.$emit('close')
                            }
                        })
                } else if (this.selectedUserSelectList.systemName === 'weathertype') {
                    this.createUpdateWeatherType({
                        deleteListItem: false,
                        cWeatherTypeId: null,
                        businessAreaTypeId: this.selectedUserSelectList.businessAreaTypeId,
                        description: this.enteredNewItem
                    })
                        .then((response) => {
                            if (response.status === 200) {
                                this.$emit('close')
                            }
                        })
                }
                this.enteredNewItem = null
            }
        },

        openModal (view, listItem) {
            new Promise((resolve, reject) => {
                resolve(this.setSelectedUserSelectListItem(listItem))
            }).then(() => {
                this.$emit('open', view)
            })
        }
    },
    created () {
        this.setSelectedUserSelectList(null)
        if (this.applicationList.filter(app => app.value.toLowerCase() === 'drive').length > 0) {
            new Promise((resolve, reject) => {
                resolve(this.setApplication(this.applicationList.filter(app => app.value.toLowerCase() === 'drive')[0].key))
            }).then(() => {
                this.setAllCodeLists()
                this.setApplicationSettingsDrive()
            })
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/administration/drive/administration-selectlists.vue